import {
  Button,
  CaptionLabel,
  CaptionProps,
  IconLeft,
  IconRight,
  useDayPicker,
  useNavigation,
} from 'react-day-picker';

import s from './CustomCaption.module.css';

export const CustomCaption = (props: CaptionProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();
  const { id, displayMonth } = props;
  const {
    classNames,
    styles,
    labels: { labelPrevious, labelNext },
  } = useDayPicker();

  const previousLabel = labelPrevious(previousMonth);
  const previousClassName = [
    classNames.nav_button,
    classNames.nav_button_previous,
  ].join(' ');

  const nextLabel = labelNext(nextMonth);
  const nextClassName = [
    classNames.nav_button,
    classNames.nav_button_next,
  ].join(' ');

  return (
    <div className={s.caption}>
      <Button
        name="previous-month"
        aria-label={previousLabel}
        className={previousClassName}
        style={styles.nav_button_previous}
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}
      >
        <IconLeft className={classNames.nav_icon} style={styles.nav_icon} />
      </Button>

      <CaptionLabel id={id} displayMonth={displayMonth} />
      <Button
        name="next-month"
        aria-label={nextLabel}
        className={nextClassName}
        style={styles.nav_button_next}
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}
      >
        <IconRight className={classNames.nav_icon} style={styles.nav_icon} />
      </Button>
    </div>
  );
};
